import React from 'react'
import { injectIntl, InjectedIntlProps } from 'gatsby-plugin-intl'

import { Picture } from 'react-responsive-picture'
import { Layout } from '~/components/Layout'
import { SEO } from '~/components/SEO'
import Container from '~/components/Layout/Container'
import FaqMenu from '~/components/faq/FaqMenu'
import ContactLink from '~/components/faq/ContactLink'
import { keysStartingWith } from '~/helpers/intl-helper'

type Props = { section: 'business' | 'partner' | 'technical' } & InjectedIntlProps

const Index: React.FC<Props> = ({ intl: { formatMessage, messages }, section }) => {
  return (
    <Layout>
      <SEO title={formatMessage({ id: `faq.${section}.title` })} />
      <Container className="faq-container u-flex">
        <div>
          <FaqMenu />
        </div>

        <div>
          <div className="u-flex u-flex-align-center faq-title">
            <Picture
              sources={[
                {
                  srcSet: `/images/icons/${section}-circle.png 1x, /images/icons/${section}-circle@2x.png 2x`,
                  type: 'image/jpeg',
                },
              ]}
            />
            <div>{formatMessage({ id: `faq.${section}.title` })}</div>
          </div>

          {keysStartingWith(`faq.${section}.item`, messages).map(key => {
            return (
              <section>
                <h3>{formatMessage({ id: `${key}.title` })}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage({ id: `${key}.content` }) }} />
              </section>
            )
          })}
          <ContactLink />
        </div>
      </Container>
    </Layout>
  )
}

export default injectIntl(Index)
